import React from "react";
import LayoutHomepage from "../layout/LayoutHomepage";
import DrinkFood from "../assets/images/drink-food-home.svg";
import { Link } from "react-router-dom";
import Container from "../components/misc/Container";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";

const BusinessPartner = () => {
  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2 mb-6">
              <div className="flex w-full mt-8 mb-8">
                <Link to="/homepage">
                <p className="flex text-font-gray opacity-50">
                  Beranda{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                </Link>
                <h1 className="text-font-gray">Menjadi partner bisnis</h1>
              </div>
              <div className="py-4 rounded bg-white">
                {/* Section Agreement */}
                <div className=" flex py-12">
                  <div className="flex flex-col w-6/12 ">
                    <h3
                      className="text-gray-600
                     tracking-0-78 text-3xl font-semibold ml-4"
                    >
                      Atur kebutuhan kantormu jadi lebih baik.
                    </h3>
                    <Link to="/form">
                    <button className="bg-basic-orange p-4 m-8 text-white rounded-md text-2xl ml-4">
                      Daftar untuk Perusahaan
                    </button>
                    </Link>
                  </div>
                  <div className="flex w-6/12 ">
                    <img src={DrinkFood} className="w-8/12 self-end" alt="" />
                  </div>
                </div>
                <h3 className="text-center mb-8 mt-16 font-hairline text-2xl">
                  Tiga langkah untuk memulai berbelanja semudah itu
                </h3>
                {/* Help menu section */}
                <div className="flex flex-row w-full mr-6 ml-6 mb-6">
                  {/* Help start first item */}
                  <div>
                    <div class="flex">
                      <div class="flex-none text-gray-700 m-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 70 70"
                        >
                          <path
                            id="Path_1704"
                            data-name="Path 1704"
                            d="M35,0A35,35,0,1,1,0,35,35,35,0,0,1,35,0Z"
                            fill="#f86542"
                          />
                          <text
                            id="Page_Title"
                            data-name="Page Title"
                            transform="translate(23 46)"
                            fill="#fff"
                            font-size="35"
                            font-family="NunitoSans-SemiBold, Nunito Sans"
                            font-weight="600"
                            letter-spacing="0.02em"
                          >
                            <tspan x="0" y="0">
                              1
                            </tspan>
                          </text>
                        </svg>
                      </div>
                      <div class="flex-auto text-gray-700">
                        <h5 className="ml-2 text-lg font-semibold">
                          Registrasi
                        </h5>
                        <p className="m-2">
                          Klik tombol registrasi dan isi formulir untuk
                          bergabung
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* end of help start first item */}

                  {/* Help start second item */}
                  <div>
                    <div class="flex">
                      <div class="flex-none text-gray-700 m-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 70 70"
                        >
                          <circle
                            id="Ellipse_405"
                            data-name="Ellipse 405"
                            cx="35"
                            cy="35"
                            r="35"
                            fill="#f86542"
                          />
                          <text
                            id="Page_Title"
                            data-name="Page Title"
                            transform="translate(25 46)"
                            fill="#fff"
                            font-size="35"
                            font-family="NunitoSans-SemiBold, Nunito Sans"
                            font-weight="600"
                            letter-spacing="0.02em"
                          >
                            <tspan x="0" y="0">
                              2
                            </tspan>
                          </text>
                        </svg>
                      </div>
                      <div class="flex-auto text-gray-700">
                        <h5 className="ml-2 text-lg font-semibold">
                          Daftar Akun
                        </h5>
                        <p className="m-2">
                          Team sales kami akan menghubungi untuk mengatur akunmu
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* end of help start second item */}

                  {/* Help start third item */}
                  <div>
                    <div class="flex">
                      <div class="flex-none text-gray-700 m-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 70 70"
                        >
                          <circle
                            id="Ellipse_406"
                            data-name="Ellipse 406"
                            cx="35"
                            cy="35"
                            r="35"
                            fill="#f86542"
                          />
                          <text
                            id="Page_Title"
                            data-name="Page Title"
                            transform="translate(25 46)"
                            fill="#fff"
                            font-size="35"
                            font-family="NunitoSans-SemiBold, Nunito Sans"
                            font-weight="600"
                            letter-spacing="0.02em"
                          >
                            <tspan x="0" y="0">
                              3
                            </tspan>
                          </text>
                        </svg>
                      </div>
                      <div class="flex-auto text-gray-700">
                        <h5 className="ml-2 text-lg font-semibold">
                          Pesan dan nikmati
                        </h5>
                        <p className="m-2">
                          Buat pesanan dan diantarkan di hari yang sama
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* end of help start third item */}
                </div>
                {/* Help menu section */}
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default BusinessPartner;
